module.exports = __webpack_public_path__ + "img/devices.eb280bd9.svg";